module.exports = "pegasus/assets/header-fall-space-1.jpg";